import React from "react"
import Image from "../components/image"

export default function Hero({
  bgColor,
  video,
  image,
  title,
  text,
  widthLarge,
}) {
  return (
    <section
      className={"hero" + (bgColor ? " theme-bg-color--" + bgColor : "")}
    >
      {title ? (
        <div className="hero__content">
          <div
            className={
              widthLarge
                ? "hero__content__inner hero__content__inner--large"
                : "hero__content__inner"
            }
          >
            <h1 className="title--primary title--uppercase">{title}</h1>{" "}
            {text ? <p dangerouslySetInnerHTML={{ __html: text }}></p> : null}
          </div>
        </div>
      ) : null}
      {video ? (
        <div className="hero__video">
          <video src={video} muted autoPlay loop playsInline></video>
        </div>
      ) : image ? (
        <div className="hero__image">
          <Image path={image} />
        </div>
      ) : null}
    </section>
  )
}
